import React, { memo } from 'react';

import { AdaptiveTableCell } from '@components/common';

import { useDownloadFile } from '@hooks/common/useDownloadFile';

import { ASSET_ICONS } from '@components/Map/Markers/constants';

import styles from './AssetCell.module.scss';

interface IAssetCellProps {
	assetName: string;
	id?: string;
}

const AssetCell = ({
	assetName,
	id,
}: IAssetCellProps) => {
	const { downloadUrl } = useDownloadFile({ id });
	const backgroundImage = downloadUrl || ASSET_ICONS.DEFAULT_ASSET;

	return (
		<div className={styles.container}>
			<div
				className={styles.image}
				style={{
					backgroundImage: `url(${backgroundImage})`,
				}}>
				{!downloadUrl}
			</div>
			<AdaptiveTableCell text={assetName} />
		</div>
	);
};

export default memo(AssetCell);
